import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const postCoordinator = async ({
  email,
  first_name,
  last_name,
  head_user,
  trials,
  typeOfStaff,
}) => {
  const token = localStorage.getItem("token");

  const payload = { email, first_name, last_name, head_user, trials, typeOfStaff };

  const { data } = await axios.post(
    `${__API_URL__}/api/patient/patient/add_coordinator/`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return data;
};

const useAddCoordinatorMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postCoordinator,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["coordinators", variables.typeOfStaff] });
    },
  });
};

export default useAddCoordinatorMutation;
